import { LogoutOutlined } from "@ant-design/icons";
import { Button, Tag } from "antd";
import { useAuth } from "react-oidc-context";
import { PageHeader } from "../components/PageHeader";
import { initialsOf } from "../components/UserMenu";
import { useTranslate } from "../i18n";

export const AccountPage = () => {
    const auth = useAuth();
    const t = useTranslate();

    const signOut = async () => {
        localStorage.removeItem("token");
        await auth.signoutRedirect({
            post_logout_redirect_uri: window.location.origin,
            id_token_hint: auth.user?.id_token
        })
        await auth.removeUser();
    };

    if (!auth.isAuthenticated) {
        return <div>{t("account.notAuthenticated")}</div>;
    }

    const name = auth.user?.profile?.name ?? auth.user?.profile?.preferred_username ?? "";
    const email = auth.user?.profile?.email ?? "";

    return (
        <>
            <PageHeader title={t("account.title")} />
            <section className="card account-card">
                <div className="account-card__head">
                    <span className="avatar account-card__avatar">{initialsOf(name, email)}</span>
                    <div>
                        <div className="account-card__name">{name}</div>
                        <div className="account-card__sub">
                            <Tag color="green">{t("nav.role")}</Tag>
                        </div>
                    </div>
                </div>

                {email.length > 0 ? (
                    <dl className="account-card__rows">
                        <div className="account-card__row">
                            <dt>{t("account.email")}</dt>
                            <dd>{email}</dd>
                        </div>
                    </dl>
                ) : null}

                <Button danger icon={<LogoutOutlined />} onClick={signOut}>
                    {t("common.signOut")}
                </Button>
            </section>
        </>
    );
}
